import { DEFAULT_BRANDING } from '../../redux/slices/branding/brandingSlice';
import { KA_VISUALIZATION_DEFAULTS } from '../agents/kaVisualizationDefaults';

const iframeState = {
  flipCard: {
    publisher: {
      name: 'Demo Name',
      logo: '',
    },
    actionPage: {
      title: 'Are you ready to take action?',
      description: 'You can be part of the solution. Take action now.',
    },
    theme: {
      primaryColor: DEFAULT_BRANDING.primaryColor,
      darkTheme: false,
      language: '',
      fontScale: 1,
      logoScale: 1,
      fontFamily: {
        fontType: 'googleFont',
        fontName: KA_VISUALIZATION_DEFAULTS.fontFamily,
      },
      isAdvertisement: false,
      outerBorderRadius: '16px 16px 16px 16px',
      animatedBorder: {
        isActive: false,
        color1: '#7c3aed',
        color2: '#fe8fb5',
        color3: '#ffbe7b',
      },
    },
    title: '',
  },
  config: {
    mode: 'create',
    sessionId: '',
    embed: true,
    pageURL: '',
    previewConfig: {
      cardSide: 'front',
      selectedActionIndex: -1,
      showEndScreen: false,
    },
    gatedEngagement: false,
  },
};

export default iframeState;
